import colors from '../../colors';
import sizes from '../../sizes';

const darkNative = {
    current: {
        focus: {
            container: {
                borderWidth: 2,
                borderColor: colors.green500,
                borderRadius: sizes.radius.xs,
                borderBottomWidth: 2,
                borderBottomColor: colors.primary500,
                paddingBottom: 8,
                paddingTop: 0,
                paddingLeft: 4,
                paddingRight: 4,
                height: 28
            }
        }
    },
    inactive: {
        focus: {
            container: {
                borderWidth: 2,
                borderColor: colors.green500,
                borderRadius: sizes.radius.xs,
                paddingBottom: 8,
                paddingTop: 0,
                paddingLeft: 4,
                paddingRight: 4,
                height: 28
            }
        }
    },
    panel: {
        padding: `0 ${sizes.fixedSpacing['md']}px`
    }
};

export default darkNative;
